import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';

import { StoreUtil } from 'doctivity-shared/utils';
import { DynamicTable } from 'components';
import { ActivityLogsUtil } from 'utils';
import { activityLogsByUserId } from 'store/actions/activityLogsActions';
import { LocationsTabs } from './LocationsTabs';

const columns = [
  {
    label: 'Name',
    key: 'name',
    fulltext: true,
    sortable: false,
    showFilter: false,
  },
  {
    label: 'Address',
    key: 'address1',
    style: { minWidth: 120 },
    format: (address1, location) =>
      location.address2 ? address1 + ', ' + location.address2 : address1,
    filterFormatter: (value, committed) => {
      if (committed) {
        return LocationsUtil.formatAddress1(value);
      }
      return value;
    },
    sortable: false,
    showFilter: false,
  },
  {
    label: 'City',
    key: 'city',
    fulltext: true,
    sortable: false,
    showFilter: false,
  },
  {
    label: 'State',
    key: 'state',
    style: { width: 50 },
    filterExact: true,
    autoCapitalize: true,
    sortable: false,
    showFilter: false,
  },
  {
    label: 'Organization',
    key: 'organization.name',
    fulltext: true,
    style: { width: 320 },
    sortable: false,
    showFilter: false,
  },
];

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
});

class RecentLocationsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: {
        attributes: [
          'id',
          'name',
          'address1',
          'address2',
          'city',
          'state',
          'postal_code',
        ],
        where: {},
        include: [
          {
            association: 'organization',
            attributes: ['id', 'name', 'primary_location_id'],
            required: false,
            paranoid: false,
          },
        ],
        paranoid: false,
        limit: 25,
        offset: 0,
      },
      showLoading: true,
    };
  }

  componentDidMount() {
    const { recents } = this.props;

    if (StoreUtil.needsLoadNoCache(recents)) {
      this.fetchData();
    }
  }

  fetchData() {
    const { dispatch, userId, clientId } = this.props;

    const { query } = this.state;

    dispatch(
      activityLogsByUserId(userId, 'Locations', clientId, {
        ...query,
      })
    );
  }

  render() {
    const { recents, classes } = this.props;

    const { query} = this.state;



    return (
      <>
        <LocationsTabs tab='recent_locations' />
        <div className={classes.container}>
          <DynamicTable
            header='Recent Locations'
            showFilters={false}
            columns={columns}
            query={query}
            data={recents}
            onQueryChange={this.onQueryChange}
            getRowHref={(row) => `/locations/${row.id}`}
          />
        </div>
      </>
    );
  }

  onQueryChange = (query) => {
    this.setState({ query, showLoading: false }, this.fetchData.bind(this));
  };
}

RecentLocationsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  clientId: PropTypes.number.isRequired,
  recents: PropTypes.object.isRequired,
  userId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const { activityLogs } = state;

  const userId = state.user ? state.user.id : null;

  return {
    userId,
    clientId: state.app.selectedClient,
    recents: ActivityLogsUtil.getLocationsFromLogs(activityLogs, userId),
  };
}

const styled = withStyles(styles)(RecentLocationsPage);
const connected = connect(mapStateToProps)(styled);
export { connected as RecentLocationsPage };
